import { render } from "./LabelStockDetailPage.vue?vue&type=template&id=69cd00ab&scoped=true"
import script from "./LabelStockDetailPage.vue?vue&type=script&lang=js"
export * from "./LabelStockDetailPage.vue?vue&type=script&lang=js"

import "./LabelStockDetailPage.vue?vue&type=style&index=0&id=69cd00ab&scoped=true&lang=css"

import exportComponent from "C:\\tmp\\hybrid-web-api\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cd00ab"]])

export default __exports__